import React from 'react';
import './transitions.css';

export function SkeletonBlock({ width, height = 10, className = '', style }) {
  return (
    <span
      className={`skeleton-block ${className}`.trim()}
      style={{ width, height, ...style }}
      aria-hidden="true"
    />
  );
}

export function SkeletonMessageBubble({
  align = 'bot',
  lines = ['long', 'medium'],
  cluster = 'solo',
  showMeta = true,
}) {
  const fromClass = align === 'user' ? 'from-user' : 'from-bot';
  return (
    <div
      className={`skeleton-bubble-row ${fromClass} cluster-${cluster}`}
      aria-hidden="true"
    >
      <div className={`skeleton-bubble ${fromClass} cluster-${cluster}`}>
        {lines.map((size, index) => (
          <SkeletonBlock
            key={`${size}-${index}`}
            className={`skeleton-line ${size}`}
            height={11}
          />
        ))}
        {showMeta && (
          <div className="skeleton-meta">
            <SkeletonBlock className="skeleton-meta-time" height={7} width={36} />
          </div>
        )}
      </div>
    </div>
  );
}

/** Chat-shaped placeholder while history loads — mirrors real bubble layout */
export function ChatThreadSkeleton({ rows = 7 }) {
  const pattern = [
    { align: 'bot', lines: ['long', 'medium', 'short'], cluster: 'first' },
    { align: 'bot', lines: ['medium'], cluster: 'last', showMeta: true },
    { align: 'user', lines: ['short'], cluster: 'solo' },
    { align: 'bot', lines: ['long', 'long', 'medium'], cluster: 'solo' },
    { align: 'user', lines: ['medium'], cluster: 'first', showMeta: false },
    { align: 'user', lines: ['short'], cluster: 'last' },
    { align: 'bot', lines: ['long', 'short'], cluster: 'solo' },
  ];

  return (
    <div
      className="chat-thread-skeleton chat-anim-fade"
      role="status"
      aria-live="polite"
      aria-label="Loading messages"
    >
      {Array.from({ length: rows }, (_, index) => {
        const spec = pattern[index % pattern.length];
        return (
          <SkeletonMessageBubble
            key={`skeleton-${index}`}
            align={spec.align}
            lines={spec.lines}
            cluster={spec.cluster}
            showMeta={spec.showMeta !== false && spec.cluster !== 'first'}
          />
        );
      })}
    </div>
  );
}

/** Login bootstrap — light thread placeholders under the profile hero */
export function LoginPageSkeleton() {
  return (
    <div
      className="chat-anim-fade"
      role="status"
      aria-live="polite"
      aria-label="Loading channel"
    >
      <ChatThreadSkeleton rows={3} />
    </div>
  );
}

export default ChatThreadSkeleton;
